import type { TenantThemeDefinition } from "../../core/types.ts";
import { defaultTenantApps } from "./apps.ts";
import { defaultTenantBase } from "./base.ts";

export const defaultTenantTheme = {
  id: "default",
  brandId: "default",
  label: "IFA",
  description: "IFA 默认租户当前使用的基础风格预设。",
  base: defaultTenantBase,
  apps: defaultTenantApps,
} satisfies TenantThemeDefinition;

